import { render, staticRenderFns } from "./myGoatviewdetails.vue?vue&type=template&id=c494a4a6&"
import script from "./myGoatviewdetails.vue?vue&type=script&lang=js&"
export * from "./myGoatviewdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports